var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurrency = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C28D002F-1B4A-42E3-BBA6-B334EE58840A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components-Prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13.X.1-Blueprints---Components---New-Component",
    transform: "translate(-696.000000, -275.000000)",
    fill: "#4A4A4A",
    fillRule: "nonzero",
    stroke: "#4A4A4A",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(687.000000, 266.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,20 C7.32890625,20 4.81765625,18.9598438 2.92890625,17.0710938 C1.04015625,15.1823438 0,12.6710938 0,10 C0,7.32890625 1.04019531,4.81769531 2.92890625,2.92890625 C4.81761719,1.04011719 7.32890625,0 10,0 C12.6710938,0 15.1823438,1.04015625 17.0710937,2.92890625 C18.9598437,4.81765625 20,7.32890625 20,10 C20,12.6710938 18.9598047,15.1823047 17.0710937,17.0710938 C15.1823828,18.9598828 12.6710938,20 10,20 Z M10,1.25 C5.17523437,1.25 1.25,5.17523438 1.25,10 C1.25,14.8247656 5.17523437,18.75 10,18.75 C14.8247656,18.75 18.75,14.8247656 18.75,10 C18.75,5.17523438 14.8247656,1.25 10,1.25 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,9.375 C9.1384375,9.375 8.4375,8.6740625 8.4375,7.8125 C8.4375,6.9509375 9.1384375,6.25 10,6.25 C10.8615625,6.25 11.5625,6.9509375 11.5625,7.8125 C11.5625,8.15765625 11.8423047,8.4375 12.1875,8.4375 C12.5326953,8.4375 12.8125,8.15765625 12.8125,7.8125 C12.8125,6.47652344 11.8758594,5.3559375 10.625,5.07085937 L10.625,4.375 C10.625,4.02984375 10.3451953,3.75 10,3.75 C9.65480469,3.75 9.375,4.02984375 9.375,4.375 L9.375,5.07085937 C8.12414063,5.3559375 7.1875,6.47652344 7.1875,7.8125 C7.1875,9.36332031 8.44917969,10.625 10,10.625 C10.8615625,10.625 11.5625,11.3259375 11.5625,12.1875 C11.5625,13.0490625 10.8615625,13.75 10,13.75 C9.1384375,13.75 8.4375,13.0490625 8.4375,12.1875 C8.4375,11.8423437 8.15769531,11.5625 7.8125,11.5625 C7.46730469,11.5625 7.1875,11.8423437 7.1875,12.1875 C7.1875,13.5234766 8.12414063,14.6440625 9.375,14.9291406 L9.375,15.625 C9.375,15.9701562 9.65480469,16.25 10,16.25 C10.3451953,16.25 10.625,15.9701562 10.625,15.625 L10.625,14.9291406 C11.8758594,14.6440625 12.8125,13.5234766 12.8125,12.1875 C12.8125,10.6366797 11.5508203,9.375 10,9.375 Z",
    id: "Path"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurrency);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/currency.92073eb93e8465eeb3dec7dd1eacbf5f.svg";